import "./About.css";
const About = () => {
  return (
    <div id="about" className="position-relative pt-5 overflow-hidden w-100">
      <h1 className="fw-bold text-center mb-4" data-aos="fade-down">
        About Me
      </h1>
      <div className="container">
        <div className="row row-cols-md-2 px-0 col-md-10 mx-auto">
          <div className="d-flex text-end pe-5" data-aos="fade-right">
            <div className="text-center  m-auto">
              <div className="about-img">
                <img
                  src="/shoyeb/images/hero.png"
                  className="rounded w-100"
                  alt="about"
                />
              </div>
              <h3 className="my-3">Software Developer</h3>
            </div>
          </div>
          <div className="h-100 d-flex flex-column  m-auto ">
            <div
              className="m-auto col-lg-8 col-md-12 px-0 px-sm-auto"
              data-aos="fade-left"
            >
              <p className="about-para ">
                Hello! I&apos;am Md Shoyeb and I enjoy creating things that live
                on the internet, a{" "}
                <span className="text-green">
                  {" "}
                  software developer engineer{" "}
                </span>{" "}
                with 3 years of <span className="text-green"> experience</span>.
                I excel in full-stack development, having delivered numerous
                large-scale projects for companies and freelance clients. About
                my education, I have completed my graduate{" "}
                <span className="text-green">
                  {" "}
                  in B.Tech(Bechelor of Technology){" "}
                </span>{" "}
                Degree in from Aliah University and my diploma engineering (ECE)
                is completed from <span> Jamia Millia Islamia University </span>
                .
              </p>
              <div className="text-center ">
                <a
                  href="https://www.linkedin.com/in/md-shoyeb-49645020a/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-info"
                >
                  Read More
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="bg-green d-md-block d-none position-absolute about-empty"
          data-aos="fade-down"
        ></div>
      </div>
    </div>
  );
};

export default About;
